import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useNode, useEditor } from '@craftjs/core';

import { EDITOR_RESOLVERS } from '@common/constants';

import { createNewCellOnTableDrop } from './utils';

const TableFooter = ({ children, elementProps }) => {
  const {
    connectors: { connect },
    actions: { setCustom },
    id,
    parentId,
  } = useNode(({ data }) => ({
    parentId: data?.parent,
  }));

  const { query, actions } = useEditor();

  const { t } = useTranslation();
  const ref = useRef(null);

  const tableNode = parentId && query?.node(parentId)?.get();

  useEffect(() => {
    if (ref?.current && connect) {
      connect(ref.current);
    }
  }, [connect]);

  useEffect(() => {
    actions.history.ignore(() => {
      setCustom((props) => {
        props.displayName = t('table_footer');
      });
    });
  }, [setCustom, t]);

  useEffect(() => {
    createNewCellOnTableDrop(id, query, actions, {
      isFooter: true,
      isFixed: elementProps?.isFixed,
    });
  }, []);

  return (
    tableNode?.data?.props?.showFooter && (
      <tfoot>
        <tr ref={(ref) => connect(ref)}>{children}</tr>
      </tfoot>
    )
  );
};

const TableFooterConfigPanel = () => {
  return <div></div>;
};

export const TableFooterDefaultProps = {
  children: null,
};

TableFooter.defaultProps = TableFooterDefaultProps;

TableFooter.propTypes = {
  children: PropTypes.node,
};

TableFooter.craft = {
  displayName: EDITOR_RESOLVERS.COMMON.TABLE_FOOTER,
  name: EDITOR_RESOLVERS.COMMON.TABLE_FOOTER,
  props: TableFooterDefaultProps,
  related: { settings: TableFooterConfigPanel },
  rules: {
    isDeletable: () => false,
    canMoveIn: (incoming) => incoming.data?.displayName === 'TableCell',
  },
};

export default TableFooter;
